import './SalesDashboardCarousel.css';
import "@splidejs/react-splide/css";
import { SalesDashboardProfitCommissions } from "../../../components/SalesDashboardProfitCommissions/SalesDashboardProfitCommissions";
import SalesDashboardAcademicUnit from "../../../components/SalesDashboardAcademicUnit/SalesDashboardAcademicUnit";

const SalesDashboardCarousel = () => {
    return (
        <div className="salesDashboardCarousel--father-div">
            <div className="salesDashboardCarousel-profits-section">
                <SalesDashboardProfitCommissions />
            </div>

            <SalesDashboardAcademicUnit />
        </div >
    );
};

export default SalesDashboardCarousel;
